import { Spin } from "antd"

interface LoaderProps {
  visible: boolean
  styles?: any
}

export function Loader({ visible, styles }: LoaderProps) {
  return (
    <div
      style={{
        opacity: visible ? "1" : "0",
        transition: "opacity 100ms",
        background: "#eeeeeeaa",
        pointerEvents: "none",
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...styles
      }}
    >
      <Spin size="default" />
    </div>
  )
}
